import Title from "./Title";
import { ColumnDef } from "@tanstack/react-table";
import { useState, useEffect } from "react";
import { useNavigate } from "react-router-dom";
import Select from "react-select";
import apiService from "../../Services/apiService";
import Loading from "../General/Loading";
import PopupGlobel from "../../PopModal/PopupGlobel";
import AdvancedDataTable from "../General/Table";
type DataDto = {
  catId: number;
  name: string;
  desc: string;
  lat: string;
  long: string;
  status: string;
  categories:string[]
};
const columns: ColumnDef<DataDto>[] = [
  {
    accessorKey: "portName",
    header: "اسم المتجر",
  },
  {
    accessorKey: "branchName",
    header: "اسم الفرع",
  },
  {
    accessorKey: "enBranchId",
    header: "المعرف",
    enableHiding: true,
  },
  {
    accessorKey: "code",
    header: "رقم العقد",
  },
  {
    accessorKey: "address",
    header: "العنوان",
  },
  {
    accessorKey: "city",
    header: "المدينة",
  },
  {
    accessorKey: "area",
    header: "المنطقة",
  },  
  { 
id: "coordinates", 
header: "الاحداثيات", 
accessorFn: (row) => `${row.lat}, ${row.long}`, 
},
 {
  accessorKey: "status",
  header: "الحالة",

  cell: ({ row }) => (
    row.original.status === "نشط" ? (
      <span
        style={{
          backgroundColor: "green",
          color: "white",
          padding: "4px 8px",
          borderRadius: "5px",
        }}
      >
        نشط
      </span>
    ) : (
      <span
        style={{
          backgroundColor: "red",
          color: "white",
          padding: "4px 8px",
          borderRadius: "5px",
        }}
      >
        مقفل
      </span>
    )
  ),
},
//   { 
// id: "categories", 
// header: "النشاط", 
// cell: ({ row }) => row.original.categories.map((c) => c) .join(" - "),
//   }
 {
  id: "categories",
  header: "النشاط",
  accessorFn: (row) =>
    row.categories.join(" - "),
  cell: ({ row }) =>
    row.original.categories.join(" - "),
}
 ];

const ListOrgs = () => {
  const [loading, setLoading] = useState(false);
  const [errheader, seterrheader] = useState("");
  const [data, setData] = useState<any[]>([]);
  const [isSuccess, setIssuccess] = useState(false);
  const [isShowPopDelete, setisShowPopDelete] = useState(false);
  const [id, setID] = useState("");
  const [error, setError] = useState<string | null>(null);
  const [success, setSuccess] = useState<string | null>(null);
  const [shops, setShops] = useState<any[]>([]);
  const [shopId, setShopId] = useState("");
  const [areas, setAreas] = useState<any[]>([]);
  const [cities, setCities] = useState<any[]>([]);
  const [categories, setcategories] = useState<any[]>([]);
  const [selectedShops, setSelectedShops] = useState<Number[]>([]);
  const [selectedAreas, setSelectedAreas] = useState<string[]>([]);
  const [selectedCities, setSelectedCities] = useState<string[]>([]);
  const [selectedCategories, setSelectedCategories] = useState<Number[]>([]);
  const [searchValue, setSearchValue] = useState("");
  const [filterShops, setfilterShops] = useState<any[]>([]);
  const [branchesData, setbranchesData] = useState<any[]>([]);
  const navigate = useNavigate();
  useEffect(() => {
    setLoading(true);
    fetshShops(0);
    fetshAreas(0);
    fetshCategories(0);
    setLoading(false);
  }, []);
  const options = shops.map((item) => ({
    value: item.shopId,
    label: item.portName,
    data: item, // keep the whole object
  }));
  const fetshShops = async (startIndex: number): Promise<void> => {
    try {
      debugger;
      const result = await apiService.fetchGetData("api/GetShops", {});
      setShops(result.data);
      setfilterShops(result.data);
    } catch (error) {
      console.error("Error fetching tags:", error);
      setShops([]); // Handle error case
    }
  };
  const fetshAreas = async (startIndex: number): Promise<void> => {
    try {
      const result = await apiService.fetchGetData("api/GetCitiesAndAreas", {});
      setAreas(result.areas);
      setCities(result.cities);
    } catch (error) {
      console.error("Error fetching tags:", error);
      setAreas([]);
      setCities([]);
      // Handle error case
    }
  };
  const fetshCategories = async (startIndex: number): Promise<void> => {
    try {
      debugger;
      const result = await apiService.fetchGetData("api/GetCategories", {});
      setcategories(result.data);
    } catch (error) {
      console.error("Error fetching tags:", error);
      setcategories([]); // Handle error case
    }
  };
  const filterBranches = async (): Promise<void> => {
    setLoading(true);
    console.log(selectedCities);
    try {
      const result = await apiService.fetchData("api/FilterFullBranches", {
        ShopIds: selectedShops,
        Regions: selectedAreas,
        Cities: selectedCities,
        ServiceIds: selectedCategories,
        PageNumber: 1,
        PageSize: 0,
      });

      setData(result.data);
      console.log(result.data);
      setLoading(false);
    } catch (error) {
      console.error("Error fetching tags:", error);
      setShops([]); // Handle error case
    }
  };
  const handleCitySearch = (e: React.KeyboardEvent<HTMLInputElement>) => {
    //if (e.key === "Enter") {
    const search = searchValue.trim().toLowerCase();
    if (search !== "") {
      const result = cities.filter((city) =>
        city.toLowerCase().includes(search),
      );

      setCities(result);
    } else fetshAreas(0);

    //}
  };
  const handleAreaSearch = (e: React.KeyboardEvent<HTMLInputElement>) => {
    //if (e.key === "Enter") {
    const search = searchValue.trim().toLowerCase();
    if (search !== "") {
      const result = areas.filter((area) =>
        area.toLowerCase().includes(search),
      );

      setAreas(result);
    } else fetshAreas(0);

    //}
  };
  const openEditPage = (id: any) => {
    navigate("/admin/mngBranches?no=" + id);
  };
  const deleteData = async () => {
    try {
      setLoading(true);
      const result = await apiService.fetchGetData("api/RemoveBranch", {
        no: id,
      });
      if (result.isOk) {
        setSuccess("✅" + result.errAr);
      } else setError("❌" + result.errAr);
      setisShowPopDelete(false);
    } catch (error) {
      console.error(error);
    }
    setLoading(false);
  };
  const openModalDelete = (id: any) => {
    setID(id);
    setisShowPopDelete(true);
  };
  const handleٍShopsSearch = (e: React.KeyboardEvent<HTMLInputElement>) => {
    //if (e.key === "Enter") {
    const search = searchValue.trim().toLowerCase();
    if (search !== "") {
      const result = filterShops.filter((shop) =>
        shop.portName.toLowerCase().includes(search),
      );
      setShops(result);
    } else setShops(filterShops);
  };
  return (
    <>
      {loading && <Loading />}
      {isShowPopDelete && (
        <PopupGlobel
          approveAction={() => deleteData()}
          cancelAction={() => {
            setisShowPopDelete(false);
          }}
          btnApproveTitle="حذف"
          btnCancelTitle="تراجع"
          title="تاكيد الحذف"
          popupType={2}
        >
          <p>هل انت متاكد من حذف البيانات؟ </p>
        </PopupGlobel>
      )}
      <main className="relative pt-16 min-h-screen bg-surface">
        <div className="flex flex-col w-full h-full p-margin-desktop gap-gutter max-w-[1200px] mx-auto">
          <Title
            pageName="البحث العام فروع المتاجر "
            pageDesc=""
            isSearch={false}
            isAdd={true} 
            addEvent={() => navigate("/admin/mngBranches")}
            AddText="إضافة فرع متجر "
          />
          <div className="grid grid-cols-1 lg:grid-cols-12 gap-8">
            {/* Main Content Area */}
            <div className="lg:col-span-12 flex flex-col gap-8">
              {/*Filter */}
              <div className="bg-surface-container-lowest rounded-2xl border border-outline-variant/30 p-5 shadow-sm">
                <div className="flex items-center justify-between pb-3.5 mb-4 border-b border-surface-variant/50">
                  <div className="flex items-center gap-2 text-on-surface font-semibold text-sm">
                    <span className="material-symbols-outlined text-vibrant-orange text-xl">
                      filter_alt
                    </span>
                    <span>البحث المتقدم والتصفية</span>
                  </div>
                  <span className="text-xs text-on-surface-variant">
                    تصفية حسب المتجر ونوع النشاط والحساب
                  </span>
                </div>
                <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-12 gap-3.5 items-end">
                  {/* Store Filter Dropdown */}
                  <div className="flex-1 min-w-[250px] relative group">
                    <button className="w-full flex items-center justify-between bg-surface-container-low hover:bg-surface-container px-4 py-2.5 rounded-lg transition-colors text-right">
                      <span className="font-label-md text-label-md text-on-surface-variant flex items-center gap-2">
                        <span className="material-symbols-outlined text-[18px]">
                          storefront
                        </span>
                        <span className="selected-count bg-primary text-on-primary px-1.5 rounded text-[10px]">
                          {selectedShops.length}
                        </span>
                        كل المتاجر
                      </span>
                      <span className="material-symbols-outlined text-[16px] text-outline group-hover:rotate-180 transition-transform">
                        expand_more
                      </span>
                    </button>
                    <div className="absolute top-full right-0 pt-2 w-64 opacity-0 group-hover:opacity-100 pointer-events-none group-hover:pointer-events-auto transition-all duration-200 z-30">
                      <div className="bg-surface/95 backdrop-blur-xl rounded-xl shadow-2xl border border-primary/10 p-2 transform origin-top scale-95 group-hover:scale-100 transition-transform duration-200">
                        <div className="relative">
                          <span className="material-symbols-outlined absolute right-3 top-1/2 -translate-y-1/2 text-outline text-[18px]">
                            search
                          </span>
                          <input
                            className="w-full bg-surface-container-highest/50 border border-outline-variant/30 rounded-lg py-2 pr-10 pl-3 text-label-md focus:outline-none focus:border-primary transition-colors"
                            placeholder="بحث عن المتجر..."
                            type="text"
                            value={searchValue}
                            onChange={(e) => {
                              setSearchValue(e.target.value);
                            }}
                            onKeyDown={handleٍShopsSearch}
                          />
                        </div>
                        <div className="flex flex-col gap-1">
                          {shops.map((item) => (
                            <label className="flex items-center gap-3 p-2 hover:bg-surface-container rounded-lg cursor-pointer transition-colors">
                              <input
                                id={item.shopId}
                                className="w-4 h-4 rounded border-outline accent-primary"
                                type="checkbox"
                                checked={selectedShops.includes(item.shopId)}
                                onChange={(e) => {
                                  if (e.target.checked) {
                                    // Add shopId
                                    setSelectedShops((prev) => [
                                      ...prev,
                                      item.shopId,
                                    ]);
                                  } else {
                                    // Remove shopId
                                    setSelectedShops((prev) =>
                                      prev.filter((id) => id !== item.shopId),
                                    );
                                  }
                                }}
                              />
                              <span className="text-label-md">
                                {" "}
                                {item.portName}
                              </span>
                            </label>
                          ))}
                        </div>
                      </div>
                    </div>
                  </div>
                  <div className="w-px h-12 bg-outline-variant/30 hidden md:block" /> 
                  <div className="w-px h-12 bg-outline-variant/30 hidden md:block" /> 
                  <div className="flex-1 min-w-[160px] relative group">
                    <button className="w-full    flex items-center justify-between bg-surface-container-low hover:bg-surface-container px-4 py-2.5 rounded-lg transition-colors text-right">
                      <span className="font-label-md text-label-md text-on-surface-variant flex items-center gap-2">
                        <span className="material-symbols-outlined text-[18px]">
                          location_city
                        </span>
                        <span className="selected-count bg-primary text-on-primary px-1.5 rounded text-[10px]">
                          {selectedCities.length}
                        </span>
                        المدن
                      </span>
                      <span className="material-symbols-outlined text-[16px] text-outline group-hover:rotate-180 transition-transform">
                        expand_more
                      </span>
                    </button>
                    <div className="absolute top-full right-0 pt-2 w-72 opacity-0 group-hover:opacity-100 pointer-events-none group-hover:pointer-events-auto transition-all duration-200 z-30">
                      <div className="bg-surface/95 backdrop-blur-xl rounded-xl shadow-2xl border border-primary/10 p-3 transform origin-top scale-95 group-hover:scale-100 transition-transform duration-200">
                        <div className="flex flex-col gap-3">
                          <div className="relative">
                            <span className="material-symbols-outlined absolute right-3 top-1/2 -translate-y-1/2 text-outline text-[18px]">
                              search
                            </span>
                            <input
                              className="w-full bg-surface-container-highest/50 border border-outline-variant/30 rounded-lg py-2 pr-10 pl-3 text-label-md focus:outline-none focus:border-primary transition-colors"
                              placeholder="بحث عن مدينة..."
                              type="text"
                              value={searchValue}
                              onChange={(e) => {
                                setSearchValue(e.target.value);
                              }}
                              onKeyDown={handleCitySearch}
                            />
                          </div>
                          <div className="flex flex-col gap-1 max-h-48 overflow-y-auto">
                            {cities.map((item) => (
                              <label
                                key={item}
                                className="flex items-center gap-3 p-2 hover:bg-surface-container rounded-lg cursor-pointer transition-colors group/item"
                              >
                                <input
                                  className="w-4 h-4 rounded border-outline accent-primary"
                                  type="checkbox"
                                  checked={selectedCities.includes(item)}
                                  onChange={(e) => {
                                    if (e.target.checked) {
                                      // Add city
                                      setSelectedCities((prev) => [
                                        ...prev,
                                        item,
                                      ]);
                                    } else {
                                      // Remove city
                                      setSelectedCities((prev) =>
                                        prev.filter((city) => city !== item),
                                      );
                                    }
                                  }}
                                />

                                <span className="text-label-md group-hover/item:text-primary transition-colors">
                                  {item}
                                </span>
                              </label>
                            ))}
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                  <div className="w-px h-8 bg-outline-variant/30 hidden md:block" /> 
                  <div className="flex-1 min-w-[200px] relative group">
                    <button className="w-full flex items-center justify-between bg-surface-container-low hover:bg-surface-container px-4 py-2.5 rounded-lg transition-colors text-right">
                      <span className="font-label-md text-label-md text-on-surface-variant flex items-center gap-2">
                        <span className="material-symbols-outlined text-[18px]">
                          map
                        </span>
                        <span className="selected-count bg-primary text-on-primary px-1.5 rounded text-[10px]">
                          {selectedAreas.length}
                        </span>
                        كل المناطق
                      </span>
                      <span className="material-symbols-outlined text-[16px] text-outline group-hover:rotate-180 transition-transform">
                        expand_more
                      </span>
                    </button>
                    <div className="absolute top-full right-0 pt-2 w-72 opacity-0 group-hover:opacity-100 pointer-events-none group-hover:pointer-events-auto transition-all duration-200 z-30">
                      <div className="bg-surface/95 backdrop-blur-xl rounded-xl shadow-2xl border border-primary/10 p-3 transform origin-top scale-95 group-hover:scale-100 transition-transform duration-200">
                        <div className="flex flex-col gap-3">
                          <div className="relative">
                            <span className="material-symbols-outlined absolute right-3 top-1/2 -translate-y-1/2 text-outline text-[18px]">
                              search
                            </span>
                            <input
                              className="w-full bg-surface-container-highest/50 border border-outline-variant/30 rounded-lg py-2 pr-10 pl-3 text-label-md focus:outline-none focus:border-primary transition-colors"
                              placeholder="بحث عن منطقة..."
                              type="text"
                              value={searchValue}
                              onChange={(e) => {
                                setSearchValue(e.target.value);
                              }}
                              onKeyDown={handleAreaSearch}
                            />
                          </div>
                          <div className="flex flex-col gap-1 max-h-48 overflow-y-auto">
                            {areas.map((item) => (
                              <label className="flex items-center gap-3 p-2 hover:bg-surface-container rounded-lg cursor-pointer transition-colors group/item">
                                <input
                                  className="w-4 h-4 rounded border-outline accent-primary"
                                  type="checkbox"
                                  checked={selectedAreas.includes(item)}
                                  onChange={(e) => {
                                    if (e.target.checked) {
                                      // Add area
                                      setSelectedAreas((prev) => [
                                        ...prev,
                                        item,
                                      ]);
                                    } else {
                                      // Remove area
                                      setSelectedAreas((prev) =>
                                        prev.filter((area) => area !== item),
                                      );
                                    }
                                  }}
                                />
                                <span className="text-label-md group-hover/item:text-primary transition-colors">
                                  {item}
                                </span>
                              </label>
                            ))}
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                  <div className="w-px h-8 bg-outline-variant/30 hidden md:block" />
                  <div className="w-px h-8 bg-outline-variant/30 hidden md:block" />
                  <div className="flex-1 min-w-[250px] relative group">
                    <button className="w-full flex items-center justify-between bg-surface-container-low hover:bg-surface-container px-4 py-2.5 rounded-lg transition-colors text-right">
                      <span className="font-label-md text-label-md text-on-surface-variant flex items-center gap-2">
                        <span className="material-symbols-outlined text-[18px]">
                          mobile_arrow_right
                        </span>
                        <span className="selected-count bg-primary text-on-primary px-1.5 rounded text-[10px]">
                          {selectedCategories.length}
                        </span>
                        كل الخدمات
                      </span>
                      <span className="material-symbols-outlined text-[16px] text-outline group-hover:rotate-180 transition-transform">
                        expand_more
                      </span>
                    </button>
                    <div className="absolute top-full right-0 pt-2 w-72 opacity-0 group-hover:opacity-100 pointer-events-none group-hover:pointer-events-auto transition-all duration-200 z-30">
                      <div className="bg-surface/95 backdrop-blur-xl rounded-xl shadow-2xl border border-primary/10 p-3 transform origin-top scale-95 group-hover:scale-100 transition-transform duration-200">
                        <div className="flex flex-col gap-3">
                          <div className="flex flex-col gap-1 max-h-48 overflow-y-auto">
                            {categories.map((item) => (
                              <label className="flex items-center gap-3 p-2 hover:bg-surface-container rounded-lg cursor-pointer transition-colors group/item">
                                <input
                                  id={item.catId}
                                  className="w-4 h-4 rounded border-outline accent-primary"
                                  type="checkbox"
                                  checked={selectedCategories.includes(
                                    item.catId,
                                  )}
                                  onChange={(e) => {
                                    if (e.target.checked) {
                                      // Add category
                                      setSelectedCategories((prev) => [
                                        ...prev,
                                        item.catId,
                                      ]);
                                    } else {
                                      // Remove category
                                      setSelectedCategories((prev) =>
                                        prev.filter((id) => id !== item.catId),
                                      );
                                    }
                                  }}
                                />
                                <span className="text-label-md group-hover/item:text-primary transition-colors">
                                  {item.name}
                                </span>
                              </label>
                            ))}
                          </div>
                        </div>
                      </div>
                    </div>
                  </div> 
                    <div className="w-px h-8 bg-outline-variant/30 hidden md:block" />
                  <div className="w-px h-8 bg-outline-variant/30 hidden md:block" />
                  <div className="flex-1 min-w-[160px] relative group"> 
                      <button
                        onClick={filterBranches}
                        className="flex-1 bg-vibrant-orange hover:bg-secondary-container transition-colors text-on-primary font-label-md text-xs sm:text-sm py-2 px-3 rounded-xl flex items-center justify-center gap-1.5 shadow-sm font-semibold h-[38px]"
                      >
                        <span className="material-symbols-outlined text-lg">
                          search
                        </span>
                        <span>بحث</span>
                      </button> 
                  </div>
                  {/* Action Buttons (Search & Reset) */}
                </div>
              </div>

              {/* Profile Settings */}
              <section
                className="bg-surface-container-lowest rounded-2xl p-8 shadow-sm"
                id="profile"
              >
                {error && (
                  <div className="bg-red-100 text-red-700 p-4 rounded-lg">
                    {error}
                  </div>
                )}
                {success && (
                  <div className="bg-green-100 text-green-700 p-4 rounded-lg">
                    {success}
                  </div>
                )}
                <div className="flex items-center gap-4 mb-8 pb-4 border-b border-surface-container-highest">
                  <span className="material-symbols-outlined text-[28px] text-primary">
                    person
                  </span>
                  <h2 className="font-headline-md text-headline-md text-on-surface">
                    قائمة فروع المتاجر
                  </h2>
                </div>
                <AdvancedDataTable
                  data={data}
                  columns={columns}
                  title=""
                  idName="enBranchId"
                  isShowExportExcel={true}
                  Buttons={[
                    {
                      btnTitle: "تعديل",
                      btnActionType: 1,
                      btnAction: (id) => openEditPage(id),
                    },
                    {
                      btnTitle: "حذف",
                      btnActionType: 2,
                      btnAction: (id) => openModalDelete(id),
                    },
                  ]}
                />
              </section>
            </div>
          </div>
        </div>
      </main>
    </>
  );
};

export default ListOrgs;
